import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiPlusCircle, FiTrash2 } = FiIcons;

function RealMotivesSection({ motives, addMotive, deleteMotive }) {
  const [motiveText, setMotiveText] = useState('');

  const handleAddMotive = async () => {
    if (motiveText.trim() === '') return;
    try {
      await addMotive(motiveText);
      setMotiveText('');
    } catch (error) {
      console.error('Error adding motive:', error);
    }
  };

  const handleDeleteMotive = async (id) => {
    try {
      await deleteMotive(id);
    } catch (error) {
      console.error('Error deleting motive:', error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAddMotive();
    }
  };

  return (
    <>
      <div className="mt-8 mb-8 p-8 bg-white rounded-3xl shadow-xl border border-gray-100">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-6">
          Perché lo fai?
        </h2>
        <p className="text-gray-600 mb-6 text-lg">Scrivi una motivazione per cui persegui i tuoi obiettivi e salvala per ricordarla ogni giorno.</p>
        <div className="flex flex-col sm:flex-row gap-4">
          <input
            type="text"
            value={motiveText}
            onChange={(e) => setMotiveText(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Scrivi qui la tua motivazione..."
            className="flex-1 p-4 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 text-lg"
          />
          <button
            onClick={handleAddMotive}
            className="p-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-3"
          >
            <SafeIcon icon={FiPlusCircle} />
            Salva
          </button>
        </div>
      </div>

      <div className="mt-8 mb-8 p-8 bg-white rounded-3xl shadow-xl border border-gray-100">
        <div className="flex items-center mb-6">
          <div className="bg-gradient-to-r from-pink-500 to-rose-500 p-3 rounded-2xl mr-4 shadow-lg">
            <SafeIcon icon={FiHeart} className="text-white text-4xl" />
          </div>
          <h2 className="text-3xl font-bold bg-gradient-to-r from-pink-500 to-rose-500 bg-clip-text text-transparent">
            Motivi Reali
          </h2>
        </div>
        <div>
          {motives.length === 0 ? (
            <p className="text-gray-500 italic p-6 bg-gradient-to-r from-gray-50 to-white rounded-3xl shadow-lg border border-gray-100">
              Nessun motivo reale salvato. Aggiungine uno qui sopra!
            </p>
          ) : (
            <ul className="space-y-4">
              {motives.map(motive => (
                <li key={motive.id} className="flex items-start p-6 bg-gradient-to-r from-gray-50 to-white rounded-3xl shadow-lg justify-between border border-gray-100">
                  <p className="text-gray-800 flex-1 text-lg font-medium">{motive.text}</p>
                  <button
                    onClick={() => handleDeleteMotive(motive.id)}
                    className="ml-4 text-gray-400 hover:text-red-500 transition-colors duration-200 focus:outline-none p-2 rounded-xl hover:bg-red-50"
                  >
                    <SafeIcon icon={FiTrash2} />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
}

export default RealMotivesSection;